export default __webpack_public_path__ + "static/tipping-7f1461c52495c9c204130d5a9247a726.jpg";